(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-buscar"]) return;
  try {
    
(function(){
  // Mismo criterio que la cabecera: con dos o mas palabras se acota al titulo,
  // porque el texto libre arrastra cualquier ficha que mencione la palabra en
  // la descripcion. Con una sola palabra se deja libre, para que un color
  // suelto siga encontrando los descatalogados, que lo llevan en un metacampo.
  function precisar(q){
    if (/["']/.test(q)) return q;
    if (/\b(AND|OR|NOT)\b/.test(q)) return q;
    var t = q.split(/\s+/).filter(Boolean);
    if (t.length < 2) return q;
    return t.map(function(p){ return 'title:"' + p + '"'; }).join(' AND ');
  }

  function iniciar(){
    var raiz = document.querySelector('[data-swc-buscar]');
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var form = raiz.querySelector('[data-swc-form]');
    var input = raiz.querySelector('[data-swc-input]');
    if (!form || !input) return;
    raiz.dataset.swcListo = '1';

    form.addEventListener('submit', function(e){
      var v = input.value.trim();
      if (!v) return;
      e.preventDefault();
      window.location.href = form.getAttribute('action') + '?q=' + encodeURIComponent(precisar(v)) + '&type=product';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-ficha-color"]) return;
  try {
    
(function(){
  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var slides = raiz.querySelectorAll('[data-swc-slide]');
    if (slides.length < 2) return;
    raiz.dataset.swcListo = '1';

    var tiras = raiz.querySelectorAll('[data-swc-ir]');
    var ant = raiz.querySelector('[data-swc-ant]');
    var sig = raiz.querySelector('[data-swc-sig]');
    var cont = raiz.querySelector('[data-swc-contador]');
    var vivo = raiz.querySelector('[data-swc-vivo]');
    var i = 0;

    function mostrar(n){
      if (n < 0) n = slides.length - 1;
      if (n >= slides.length) n = 0;
      i = n;
      for (var k = 0; k < slides.length; k++) slides[k].hidden = (k !== i);
      for (var t = 0; t < tiras.length; t++){
        var act = parseInt(tiras[t].getAttribute('data-swc-ir'), 10) === i;
        tiras[t].classList.toggle('swc-color__tira--activa', act);
        tiras[t].setAttribute('aria-current', act ? 'true' : 'false');
      }
      var txt = (i + 1) + ' / ' + slides.length;
      if (cont) cont.textContent = txt;
      if (vivo) vivo.textContent = txt;
    }

    if (ant) ant.addEventListener('click', function(){ mostrar(i - 1); });
    if (sig) sig.addEventListener('click', function(){ mostrar(i + 1); });

    for (var t = 0; t < tiras.length; t++){
      (function(btn){
        btn.addEventListener('click', function(){
          mostrar(parseInt(btn.getAttribute('data-swc-ir'), 10) || 0);
        });
      })(tiras[t]);
    }

    raiz.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft'){ e.preventDefault(); mostrar(i - 1); }
      else if (e.key === 'ArrowRight'){ e.preventDefault(); mostrar(i + 1); }
    });

    mostrar(0);
  }

  function arrancar(){
    var g = document.querySelectorAll('[data-swc-galeria]');
    for (var n = 0; n < g.length; n++) iniciar(g[n]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-ficha-descatalogado"]) return;
  try {
    
(function(){
  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var slides = raiz.querySelectorAll('[data-swc-guia-slide]');
    var tiras = raiz.querySelectorAll('[data-swc-guia-ir]');
    if (slides.length < 2) return;
    raiz.dataset.swcListo = '1';
    function mostrar(n){
      for (var k = 0; k < slides.length; k++) slides[k].hidden = (k !== n);
      for (var t = 0; t < tiras.length; t++) tiras[t].setAttribute('aria-current', parseInt(tiras[t].getAttribute('data-swc-guia-ir'), 10) === n ? 'true' : 'false');
    }
    for (var t = 0; t < tiras.length; t++){
      tiras[t].addEventListener('click', function(){ mostrar(parseInt(this.getAttribute('data-swc-guia-ir'), 10) || 0); });
    }
  }
  function arrancar(){
    var g = document.querySelectorAll('[data-swc-guia-galeria]');
    for (var n = 0; n < g.length; n++) iniciar(g[n]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-ficha"]) return;
  try {
    
(function(){
  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var slides = raiz.querySelectorAll('[data-swc-slide]');
    if (slides.length < 2) return;
    raiz.dataset.swcListo = '1';

    var tiras = raiz.querySelectorAll('[data-swc-ir]');
    var ant = raiz.querySelector('[data-swc-ant]');
    var sig = raiz.querySelector('[data-swc-sig]');
    var cont = raiz.querySelector('[data-swc-contador]');
    var vivo = raiz.querySelector('[data-swc-vivo]');
    var i = 0;

    function mostrar(n){
      if (n < 0) n = slides.length - 1;
      if (n >= slides.length) n = 0;
      i = n;
      for (var k = 0; k < slides.length; k++) slides[k].hidden = (k !== i);
      for (var t = 0; t < tiras.length; t++){
        var act = parseInt(tiras[t].getAttribute('data-swc-ir'), 10) === i;
        tiras[t].classList.toggle('swc-ficha__tira--activa', act);
        tiras[t].setAttribute('aria-current', act ? 'true' : 'false');
      }
      var txt = (i + 1) + ' / ' + slides.length;
      if (cont) cont.textContent = txt;
      if (vivo) vivo.textContent = txt;
    }

    if (ant) ant.addEventListener('click', function(){ mostrar(i - 1); });
    if (sig) sig.addEventListener('click', function(){ mostrar(i + 1); });

    for (var t = 0; t < tiras.length; t++){
      (function(btn){
        btn.addEventListener('click', function(){
          mostrar(parseInt(btn.getAttribute('data-swc-ir'), 10) || 0);
        });
      })(tiras[t]);
    }

    raiz.addEventListener('keydown', function(e){
      if (e.key === 'ArrowLeft'){ e.preventDefault(); mostrar(i - 1); }
      else if (e.key === 'ArrowRight'){ e.preventDefault(); mostrar(i + 1); }
    });

    mostrar(0);
  }

  function arrancar(){
    var g = document.querySelectorAll('[data-swc-galeria]');
    for (var n = 0; n < g.length; n++) iniciar(g[n]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();

  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-guia-marca"]) return;
  try {
    
(function(){
  var GRUPOS = ['estado', 'pieza', 'instalacion', 'tanque', 'desague', 'lavado', 'color'];

  function norm(s){
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var lista = raiz.querySelector('[data-mg-lista]');
    if (!lista) return;
    raiz.dataset.swcListo = '1';

    var filas = Array.prototype.slice.call(raiz.querySelectorAll('[data-mg-fila]'));
    var chips = Array.prototype.slice.call(raiz.querySelectorAll('[data-mg-chip]'));
    var q = raiz.querySelector('[data-mg-q]');
    var orden = raiz.querySelector('[data-mg-orden]');
    var cuenta = raiz.querySelector('[data-mg-cuenta]');
    var vacio = raiz.querySelector('[data-mg-vacio]');
    var limpiar = Array.prototype.slice.call(raiz.querySelectorAll('[data-mg-limpiar]'));
    var toggle = raiz.querySelector('[data-mg-toggle]');
    var panel = raiz.querySelector('[data-mg-panel]');
    var badge = raiz.querySelector('[data-mg-activos]');
    var letras = raiz.querySelector('[data-mg-letras]');
    var botonesVista = Array.prototype.slice.call(raiz.querySelectorAll('[data-mg-vista]'));
    var pFotos = raiz.querySelector('[data-mg-fotos]');
    var pTabla = raiz.querySelector('[data-mg-tabla]');
    var total = filas.length;
    var estado = {};
    var vistaActual = pFotos ? 'fotos' : 'tabla';

    var params = new URLSearchParams(window.location.search);
    GRUPOS.forEach(function(g){ if (params.get(g)) estado[g] = params.get(g); });
    if (q && params.get('q')) q.value = params.get('q');
    if (orden && params.get('orden')) orden.value = params.get('orden');
    if (pFotos && (params.get('vista') === 'tabla' || Object.keys(estado).length || params.get('q'))) vistaActual = 'tabla';

    function ponerVista(v){
      vistaActual = v;
      if (!pFotos || !pTabla) return;
      pFotos.hidden = v !== 'fotos';
      pTabla.hidden = v !== 'tabla';
      botonesVista.forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-mg-vista') === v ? 'true' : 'false'); });
    }

    function valores(f, g){
      var v = f.getAttribute('data-' + g) || '';
      return v ? v.split('|') : [];
    }

    function pasa(f, excepto){
      for (var i = 0; i < GRUPOS.length; i++){
        var g = GRUPOS[i];
        if (g === excepto || !estado[g]) continue;
        if (valores(f, g).indexOf(estado[g]) < 0) return false;
      }
      var t = q ? norm(q.value.trim()) : '';
      if (t && norm(f.getAttribute('data-nombre')).indexOf(t) < 0) return false;
      return true;
    }

    function ordenar(){
      var modo = orden ? orden.value : 'az';
      Array.prototype.slice.call(raiz.querySelectorAll('[data-mg-letra]')).forEach(function(l){ l.parentNode.removeChild(l); });
      var arr = filas.slice().sort(function(a, b){
        if (modo === 'colores'){
          var d = parseInt(b.getAttribute('data-ncolores'), 10) - parseInt(a.getAttribute('data-ncolores'), 10);
          if (d) return d;
        }
        var r = norm(a.getAttribute('data-nombre')).localeCompare(norm(b.getAttribute('data-nombre')), 'es');
        return modo === 'za' ? -r : r;
      });
      var vistas = [];
      var ultima = '';
      arr.forEach(function(f){
        if (modo !== 'colores' && !f.hidden){
          var L = norm(f.getAttribute('data-nombre')).charAt(0).toUpperCase();
          if (L !== ultima){
            ultima = L;
            vistas.push(L);
            var li = document.createElement('li');
            li.className = 'swc-mg__letra';
            li.id = 'swc-mg-letra-' + L;
            li.setAttribute('data-mg-letra', L);
            li.setAttribute('aria-hidden', 'true');
            li.textContent = L;
            lista.appendChild(li);
          }
        }
        lista.appendChild(f);
      });
      if (letras){
        letras.innerHTML = '';
        vistas.forEach(function(L){
          var a = document.createElement('a');
          a.className = 'swc-mg__letra-ir';
          a.href = '#swc-mg-letra-' + L;
          a.textContent = L;
          letras.appendChild(a);
        });
        letras.hidden = vistas.length < 2;
      }
    }

    function aplicar(){
      var visibles = 0;
      filas.forEach(function(f){
        var ok = pasa(f);
        f.hidden = !ok;
        if (ok) visibles++;
      });

      chips.forEach(function(c){
        var g = c.getAttribute('data-grupo');
        var v = c.getAttribute('data-valor');
        var n = 0;
        filas.forEach(function(f){ if (pasa(f, g) && valores(f, g).indexOf(v) >= 0) n++; });
        var nEl = c.querySelector('[data-mg-n]');
        if (nEl) nEl.textContent = n;
        var activo = estado[g] === v;
        c.setAttribute('aria-pressed', activo ? 'true' : 'false');
        c.hidden = n === 0 && !activo;
      });

      ordenar();

      if (cuenta){
        var plantilla = cuenta.getAttribute('data-plantilla') || '';
        cuenta.textContent = plantilla.replace('{x}', visibles).replace('{n}', total);
      }
      if (vacio) vacio.hidden = visibles > 0;

      var activos = Object.keys(estado).length + (q && q.value.trim() ? 1 : 0);
      if (badge){
        badge.textContent = activos;
        badge.hidden = activos === 0;
      }
      limpiar.forEach(function(b){
        if (!b.closest('[data-mg-vacio]')) b.hidden = activos === 0;
      });

      var p = new URLSearchParams();
      if (pFotos && vistaActual === 'tabla') p.set('vista', 'tabla');
      GRUPOS.forEach(function(g){ if (estado[g]) p.set(g, estado[g]); });
      if (q && q.value.trim()) p.set('q', q.value.trim());
      if (orden && orden.value !== 'az') p.set('orden', orden.value);
      var s = p.toString();
      window.history.replaceState(null, '', window.location.pathname + (s ? '?' + s : ''));
    }

    botonesVista.forEach(function(b){
      b.addEventListener('click', function(){
        ponerVista(b.getAttribute('data-mg-vista'));
        aplicar();
      });
    });

    chips.forEach(function(c){
      c.addEventListener('click', function(){
        var g = c.getAttribute('data-grupo');
        var v = c.getAttribute('data-valor');
        if (estado[g] === v) delete estado[g];
        else estado[g] = v;
        aplicar();
      });
    });

    if (q){
      var espera;
      q.addEventListener('input', function(){
        clearTimeout(espera);
        espera = setTimeout(aplicar, 120);
      });
    }

    if (orden) orden.addEventListener('change', aplicar);

    limpiar.forEach(function(b){
      b.addEventListener('click', function(){
        estado = {};
        if (q) q.value = '';
        aplicar();
      });
    });

    if (toggle && panel){
      toggle.addEventListener('click', function(){
        var abierto = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', abierto ? 'false' : 'true');
        panel.classList.toggle('is-abierto', !abierto);
      });
    }

    ponerVista(vistaActual);
    aplicar();
  }

  function arrancar(){
    var r = document.querySelectorAll('[data-swc-mg]');
    for (var i = 0; i < r.length; i++) iniciar(r[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-guia-pieza"]) return;
  try {
    
(function(){
  var GRUPOS = ['estado', 'instalacion', 'tanque', 'desague', 'lavado', 'color'];
  var ICONO_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';

  function norm(s){
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var contenedor = raiz.querySelector('[data-gp-resultados]');
    if (!contenedor) return;
    raiz.dataset.swcListo = '1';

    var items = Array.prototype.slice.call(raiz.querySelectorAll('[data-gp-item]'));
    var grupos = Array.prototype.slice.call(raiz.querySelectorAll('[data-gp-grupo]'));
    var tabs = Array.prototype.slice.call(raiz.querySelectorAll('[data-gp-marca]'));
    var selects = Array.prototype.slice.call(raiz.querySelectorAll('[data-gp-filtro]'));
    var q = raiz.querySelector('[data-gp-q]');
    var cuenta = raiz.querySelector('[data-gp-cuenta]');
    var activosEl = raiz.querySelector('[data-gp-activos]');
    var vacio = raiz.querySelector('[data-gp-vacio]');
    var limpiar = Array.prototype.slice.call(raiz.querySelectorAll('[data-gp-limpiar]'));
    var total = items.length;
    var estado = { marca: '' };

    grupos.forEach(function(gr){
      var rej = gr.querySelector('[data-gp-rejilla]');
      var hijos = Array.prototype.slice.call(rej.querySelectorAll('[data-gp-item]'));
      hijos.sort(function(a, b){
        return norm(a.getAttribute('data-nombre')).localeCompare(norm(b.getAttribute('data-nombre')), 'es');
      }).forEach(function(h){ rej.appendChild(h); });
    });

    var params = new URLSearchParams(window.location.search);
    if (params.get('marca')) estado.marca = params.get('marca');
    GRUPOS.forEach(function(g){ if (params.get(g)) estado[g] = params.get(g); });
    if (q && params.get('q')) q.value = params.get('q');

    function valores(it, g){
      var v = it.getAttribute('data-' + g) || '';
      return v ? v.split('|') : [];
    }

    function pasa(it, excepto){
      if (excepto !== 'marca' && estado.marca && it.getAttribute('data-marca') !== estado.marca) return false;
      for (var i = 0; i < GRUPOS.length; i++){
        var g = GRUPOS[i];
        if (g === excepto || !estado[g]) continue;
        if (valores(it, g).indexOf(estado[g]) < 0) return false;
      }
      var t = q ? norm(q.value.trim()) : '';
      if (t && norm(it.getAttribute('data-nombre')).indexOf(t) < 0) return false;
      return true;
    }

    function aplicar(){
      var visibles = 0;
      items.forEach(function(it){
        var ok = pasa(it);
        it.hidden = !ok;
        if (ok) visibles++;
      });

      grupos.forEach(function(gr){
        var n = gr.querySelectorAll('[data-gp-item]:not([hidden])').length;
        gr.hidden = n === 0;
        var nEl = gr.querySelector('[data-gp-grupo-n]');
        if (nEl) nEl.textContent = n;
      });

      tabs.forEach(function(t){
        var m = t.getAttribute('data-gp-marca');
        var n = 0;
        items.forEach(function(it){ if (pasa(it, 'marca') && (!m || it.getAttribute('data-marca') === m)) n++; });
        var nEl = t.querySelector('[data-gp-tab-n]');
        if (nEl) nEl.textContent = n;
        t.setAttribute('aria-pressed', estado.marca === m ? 'true' : 'false');
      });

      selects.forEach(function(s){
        var g = s.getAttribute('data-gp-filtro');
        Array.prototype.forEach.call(s.options, function(op){
          if (!op.value) return;
          var n = 0;
          items.forEach(function(it){ if (pasa(it, g) && valores(it, g).indexOf(op.value) >= 0) n++; });
          op.textContent = op.getAttribute('data-base') + ' (' + n + ')';
          op.disabled = n === 0 && estado[g] !== op.value;
        });
        s.value = estado[g] || '';
        s.classList.toggle('is-activo', !!estado[g]);
      });

      if (activosEl){
        activosEl.innerHTML = '';
        GRUPOS.forEach(function(g){
          if (!estado[g]) return;
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'swc-gp__pill';
          var sp = document.createElement('span');
          sp.textContent = estado[g];
          b.appendChild(sp);
          b.insertAdjacentHTML('beforeend', ICONO_X);
          b.addEventListener('click', function(){ delete estado[g]; aplicar(); });
          activosEl.appendChild(b);
        });
      }

      if (cuenta){
        cuenta.textContent = (cuenta.getAttribute('data-plantilla') || '').replace('{x}', visibles).replace('{n}', total);
      }
      if (vacio) vacio.hidden = visibles > 0;

      var nAct = GRUPOS.filter(function(g){ return !!estado[g]; }).length + (estado.marca ? 1 : 0) + (q && q.value.trim() ? 1 : 0);
      limpiar.forEach(function(b){
        if (!b.closest('[data-gp-vacio]')) b.hidden = nAct === 0;
      });

      var p = new URLSearchParams();
      if (estado.marca) p.set('marca', estado.marca);
      GRUPOS.forEach(function(g){ if (estado[g]) p.set(g, estado[g]); });
      if (q && q.value.trim()) p.set('q', q.value.trim());
      var s = p.toString();
      window.history.replaceState(null, '', window.location.pathname + (s ? '?' + s : ''));
    }

    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        estado.marca = t.getAttribute('data-gp-marca');
        aplicar();
      });
    });

    selects.forEach(function(s){
      s.addEventListener('change', function(){
        var g = s.getAttribute('data-gp-filtro');
        if (s.value) estado[g] = s.value;
        else delete estado[g];
        aplicar();
      });
    });

    if (q){
      var espera;
      q.addEventListener('input', function(){
        clearTimeout(espera);
        espera = setTimeout(aplicar, 120);
      });
    }

    limpiar.forEach(function(b){
      b.addEventListener('click', function(){
        estado = { marca: '' };
        if (q) q.value = '';
        aplicar();
      });
    });

    aplicar();
  }

  function arrancar(){
    var r = document.querySelectorAll('[data-swc-gp]');
    for (var i = 0; i < r.length; i++) iniciar(r[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  var MINIMO = 2;
  var ESPERA = 220;

  function escapar(t){
    var d = document.createElement('div');
    d.textContent = t == null ? '' : String(t);
    return d.innerHTML;
  }

  function precisar(q){
    if (/["']/.test(q)) return q;
    if (/\b(AND|OR|NOT)\b/.test(q)) return q;
    var t = q.split(/\s+/).filter(Boolean);
    if (t.length < 2) return q;
    return t.join(' AND ');
  }

  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var form = raiz.querySelector('[data-swc-form]');
    var input = raiz.querySelector('[data-swc-input]');
    var panel = raiz.querySelector('[data-swc-panel]');
    var lista = raiz.querySelector('[data-swc-lista]');
    var estado = raiz.querySelector('[data-swc-estado]');
    var todos = raiz.querySelector('[data-swc-todos]');
    var vivo = raiz.querySelector('[data-swc-vivo]');
    var json = raiz.querySelector('[data-swc-textos]');
    if (!form || !input || !panel || !lista) return;
    raiz.dataset.swcListo = '1';

    var textos = {};
    try { textos = JSON.parse(json.textContent); } catch (e) { textos = {}; }

    var ruta = raiz.dataset.swcRuta || '/search/suggest';
    var limite = parseInt(raiz.dataset.swcLimite, 10) || 6;
    var accionBusqueda = form.getAttribute('action') || '/search';
    var idBase = input.id + '-op-';
    var temporizador = null;
    var peticion = null;
    var cache = {};
    var opciones = [];
    var indice = -1;

    function anunciar(t){ if (vivo) vivo.textContent = t || ''; }

    function urlBusqueda(consulta){
      return accionBusqueda + '?q=' + encodeURIComponent(precisar(consulta)) + '&type=product';
    }

    function cerrar(){
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
      indice = -1;
    }

    function abrir(){
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function mensaje(t){
      lista.innerHTML = '';
      opciones = [];
      todos.hidden = true;
      estado.hidden = false;
      estado.textContent = t;
      abrir();
    }

    function marcar(nuevo){
      if (!opciones.length) return;
      if (indice > -1 && opciones[indice]) opciones[indice].setAttribute('aria-selected', 'false');
      indice = nuevo;
      if (indice < 0) indice = opciones.length - 1;
      if (indice >= opciones.length) indice = 0;
      var el = opciones[indice];
      el.setAttribute('aria-selected', 'true');
      input.setAttribute('aria-activedescendant', el.id);
      if (el.scrollIntoView) el.scrollIntoView({ block: 'nearest' });
    }

    function pintar(productos, consulta){
      estado.hidden = true;
      lista.innerHTML = '';
      opciones = [];
      indice = -1;
      input.removeAttribute('aria-activedescendant');

      if (!productos.length){
        mensaje((textos.sin || '').replace('{q}', consulta));
        anunciar((textos.sin || '').replace('{q}', consulta));
        return;
      }

      productos.forEach(function(p, i){
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'swc-hero__sug';
        a.id = idBase + i;
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.setAttribute('tabindex', '-1');
        a.href = p.url;
        a.setAttribute('data-swc-event', 'select_item');
        a.setAttribute('data-swc-location', 'hero_sugerencias');

        var img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
        var alt = (p.featured_image && p.featured_image.alt) ? p.featured_image.alt : p.title;
        var marca = p.vendor ? '<span class="swc-hero__sug-marca">' + escapar(p.vendor) + '</span>' : '';
        var media = img ? '<span class="swc-hero__sug-media"><img class="swc-hero__sug-img" src="' + escapar(img) + '" alt="" loading="lazy" width="48" height="48"></span>' : '<span class="swc-hero__sug-media"></span>';

        a.innerHTML = media + '<span class="swc-hero__sug-txt">' + marca + '<span class="swc-hero__sug-nombre">' + escapar(p.title) + '</span></span>';
        a.setAttribute('aria-label', (p.vendor ? p.vendor + '. ' : '') + (alt || p.title));
        li.appendChild(a);
        lista.appendChild(li);
        opciones.push(a);
      });

      todos.href = urlBusqueda(consulta);
      todos.hidden = false;
      abrir();

      var plantilla = productos.length === 1 ? (textos.uno || '') : (textos.varios || '');
      anunciar(plantilla.replace('{n}', productos.length));
    }

    function pedir(termino){
      var url = ruta + '.json?q=' + encodeURIComponent(termino) +
        '&resources[type]=product&resources[limit]=' + limite +
        '&resources[options][unavailable_products]=show' +
        '&resources[options][fields]=title,product_type,vendor,tag,variants.title';
      var ctrl = window.AbortController ? new AbortController() : null;
      peticion = ctrl;
      return fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function(r){ if (!r.ok) throw new Error('http'); return r.json(); })
        .then(function(d){
          return (d && d.resources && d.resources.results && d.resources.results.products) || [];
        });
    }

    function buscar(consulta){
      if (cache[consulta]) { pintar(cache[consulta], consulta); return; }
      if (peticion && peticion.abort) peticion.abort();

      mensaje(textos.cargando || '');

      pedir(precisar(consulta))
        .then(function(p){
          if (p.length || precisar(consulta) === consulta) return p;
          return pedir(consulta);
        })
        .then(function(p){
          cache[consulta] = p;
          if (input.value.trim().toLowerCase() === consulta) pintar(p, consulta);
        })
        .catch(function(err){
          if (err && err.name === 'AbortError') return;
          mensaje(textos.error || '');
        });
    }

    form.addEventListener('submit', function(e){
      var v = input.value.trim();
      if (!v) return;
      e.preventDefault();
      window.location.href = urlBusqueda(v);
    });

    input.addEventListener('input', function(){
      var v = input.value.trim().toLowerCase();
      clearTimeout(temporizador);
      if (v.length < MINIMO) { cerrar(); return; }
      temporizador = setTimeout(function(){ buscar(v); }, ESPERA);
    });

    input.addEventListener('keydown', function(e){
      if (e.key === 'Escape') { cerrar(); return; }
      if (panel.hidden || !opciones.length) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); marcar(indice + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); marcar(indice - 1); }
      else if (e.key === 'Enter' && indice > -1) { e.preventDefault(); opciones[indice].click(); }
    });

    input.addEventListener('focus', function(){
      if (opciones.length && input.value.trim().length >= MINIMO) abrir();
    });

    document.addEventListener('click', function(e){
      if (!raiz.contains(e.target)) cerrar();
    });

    raiz.addEventListener('focusout', function(e){
      if (!raiz.contains(e.relatedTarget)) cerrar();
    });
  }

  function todosLosHeroes(){
    document.querySelectorAll('[data-swc-hero]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', todosLosHeroes);
  } else {
    todosLosHeroes();
  }

  document.addEventListener('shopify:section:load', function(e){
    var r = e.target.querySelector('[data-swc-hero]');
    if (r) iniciar(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-home-fotos"] && !Shopify.designMode) return;
  try {
    
(function(){
  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var caja = raiz.querySelector('[data-hf-modelos]');
    if (!caja) return;
    raiz.dataset.swcListo = '1';
    var mods = Array.prototype.slice.call(caja.querySelectorAll('[data-hf-mod]'));
    var pills = Array.prototype.slice.call(caja.querySelectorAll('[data-hf-filtro]'));
    var mas = caja.querySelector('[data-hf-mas]');
    var limite = 0;
    mods.forEach(function(m){ if (!m.hasAttribute('data-hf-extra')) limite++; });
    var abierto = false;
    var marca = '';
    function pintar(){
      var n = 0;
      mods.forEach(function(m){
        var ok = !marca || m.getAttribute('data-marca') === marca;
        if (ok) n++;
        m.hidden = !ok || (!marca && !abierto && n > limite);
      });
      if (mas) mas.parentNode.hidden = !!marca || abierto;
    }
    pills.forEach(function(p){
      p.addEventListener('click', function(){
        marca = p.getAttribute('data-hf-filtro');
        pills.forEach(function(x){ x.setAttribute('aria-pressed', x === p ? 'true' : 'false'); });
        pintar();
      });
    });
    if (mas) mas.addEventListener('click', function(){ abierto = true; pintar(); });
  }
  function arrancar(){ document.querySelectorAll('[data-swc-hf]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-hub-guia"]) return;
  try {
    
(function(){
  function norm(s){
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  function handle(s){
    return norm(s).replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function cargarTodo(raiz, caja, listo){
    var url = caja.getAttribute('data-hd-url');
    var paginas = parseInt(caja.getAttribute('data-hd-paginas'), 10) || 1;
    if (!url || !window.fetch || !window.Promise) return;
    var pedidos = [];
    var tema = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ? '&preview_theme_id=' + Shopify.theme.id : '';
    for (var p = 1; p <= paginas; p++){
      pedidos.push(fetch(url + '&page=' + p + tema, { credentials: 'same-origin' }).then(function(r){
        if (!r.ok) throw new Error(r.status);
        return r.text();
      }).then(function(txt){ return JSON.parse(txt); }));
    }
    Promise.all(pedidos).then(function(trozos){
      var todos = [];
      trozos.forEach(function(t){ todos = todos.concat(t); });
      if (!todos.length) return;
      listo(todos);
      pintarColores(raiz, caja, todos);
    }).catch(function(){});
  }

  function pintarColores(raiz, caja, todos){
    var ul = raiz.querySelector('[data-hd-colores]');
    if (!ul) return;
    var marcas = {};
    try { marcas = JSON.parse(raiz.querySelector('[data-hd-marcas]').textContent); } catch (e) { marcas = {}; }
    var prefijo = caja.getAttribute('data-hd-prefijo') || '';
    var base = caja.getAttribute('data-hd-base') || '';
    var orden = [], info = {};
    todos.forEach(function(d){
      (d.cl || []).forEach(function(c){
        if (!c) return;
        if (!info[c]){ info[c] = { n: 0, m: d.m }; orden.push(c); }
        info[c].n++;
      });
    });
    if (!orden.length) return;
    var plantilla = ul.querySelector('li');
    if (!plantilla) return;
    var frag = document.createDocumentFragment();
    orden.forEach(function(c){
      var li = plantilla.cloneNode(true);
      var a = li.querySelector('a');
      var h = handle(prefijo + '-' + info[c].m);
      a.href = (marcas[h] || base) + '?color=' + encodeURIComponent(c).replace(/%20/g, '+');
      li.querySelector('.swc-hd__color-nombre').textContent = c;
      li.querySelector('.swc-hd__color-n').textContent = info[c].n;
      frag.appendChild(li);
    });
    ul.innerHTML = '';
    ul.appendChild(frag);
  }

  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    var caja = raiz.querySelector('[data-hd-buscador]');
    var fuente = raiz.querySelector('[data-hd-datos]');
    if (!caja || !fuente) return;
    raiz.dataset.swcListo = '1';

    var datos = [];
    try { datos = JSON.parse(fuente.textContent); } catch (e) { datos = []; }
    datos.forEach(function(d){ d.k = norm(d.n + ' ' + d.m + ' ' + d.t); });
    cargarTodo(raiz, caja, function(todos){
      todos.forEach(function(d){ d.k = norm(d.n + ' ' + d.m + ' ' + d.t); });
      datos = todos;
    });

    var q = caja.querySelector('[data-hd-q]');
    var combo = caja.querySelector('[data-hd-combo]');
    var lista = caja.querySelector('[data-hd-resultados]');
    var sin = caja.querySelector('[data-hd-sin]');
    var palColores = caja.getAttribute('data-txt-colores') || '';
    var palColor = caja.getAttribute('data-txt-color') || '';
    var activo = -1;

    function cerrar(){
      lista.hidden = true;
      sin.hidden = true;
      combo.setAttribute('aria-expanded', 'false');
      activo = -1;
    }

    function marcar(n){
      var opciones = lista.querySelectorAll('[role="option"]');
      if (!opciones.length) return;
      if (n < 0) n = opciones.length - 1;
      if (n >= opciones.length) n = 0;
      activo = n;
      for (var i = 0; i < opciones.length; i++) opciones[i].setAttribute('aria-selected', i === n ? 'true' : 'false');
      q.setAttribute('aria-activedescendant', opciones[n].id);
      opciones[n].scrollIntoView({ block: 'nearest' });
    }

    function buscar(){
      var t = norm(q.value.trim());
      if (t.length < 2){ cerrar(); return; }
      var palabras = t.split(/\s+/);
      var res = datos.filter(function(d){
        return palabras.every(function(p){ return d.k.indexOf(p) >= 0; });
      }).slice(0, 8);

      lista.innerHTML = '';
      activo = -1;
      q.removeAttribute('aria-activedescendant');

      if (!res.length){
        lista.hidden = true;
        sin.hidden = false;
        combo.setAttribute('aria-expanded', 'false');
        return;
      }

      res.forEach(function(d, i){
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.className = 'swc-hd__res';
        a.href = d.u;
        a.id = 'swc-hd-op-' + i;
        a.setAttribute('role', 'option');
        a.setAttribute('aria-selected', 'false');
        a.setAttribute('data-swc-event', 'select_item');
        a.setAttribute('data-swc-location', 'hub_descatalogados_buscador');
        var cuerpo = document.createElement('span');
        var nombre = document.createElement('span');
        nombre.className = 'swc-hd__res-nombre';
        nombre.textContent = d.n;
        var meta = document.createElement('span');
        meta.className = 'swc-hd__res-meta';
        var partes = [d.m, d.t];
        if (d.c > 0) partes.push(d.c + ' ' + (d.c === 1 ? palColor : palColores));
        meta.textContent = partes.filter(Boolean).join(' · ');
        cuerpo.appendChild(nombre);
        cuerpo.appendChild(meta);
        a.appendChild(cuerpo);
        a.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m13 6 6 6-6 6"/></svg>');
        li.appendChild(a);
        lista.appendChild(li);
      });

      sin.hidden = true;
      lista.hidden = false;
      combo.setAttribute('aria-expanded', 'true');
    }

    var espera;
    q.addEventListener('input', function(){
      clearTimeout(espera);
      espera = setTimeout(buscar, 90);
    });

    q.addEventListener('keydown', function(e){
      if (e.key === 'ArrowDown'){ e.preventDefault(); if (lista.hidden) buscar(); marcar(activo + 1); }
      else if (e.key === 'ArrowUp'){ e.preventDefault(); marcar(activo - 1); }
      else if (e.key === 'Enter'){
        var opciones = lista.querySelectorAll('[role="option"]');
        var destino = opciones[activo >= 0 ? activo : 0];
        if (destino && !lista.hidden){ e.preventDefault(); window.location.href = destino.href; }
      }
      else if (e.key === 'Escape'){ cerrar(); }
    });

    document.addEventListener('click', function(e){
      if (!caja.contains(e.target)) cerrar();
    });

    q.addEventListener('focus', function(){
      if (q.value.trim().length >= 2) buscar();
    });
  }

  function arrancar(){
    var r = document.querySelectorAll('[data-swc-hd]');
    for (var i = 0; i < r.length; i++) iniciar(r[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar);
  else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-hub-marca"]) return;
  try {
    
(function(){
  function iniciar(){
    var form = document.querySelector('[data-swc-marcaform]');
    var input = document.querySelector('[data-swc-marcainput]');
    if (!form || !input || form.dataset.listo === '1') return;
    form.dataset.listo = '1';
    var marca = form.getAttribute('data-swc-marca') || '';
    form.addEventListener('submit', function(e){
      var v = input.value.trim();
      if (!v) return;
      e.preventDefault();
      var q;
      if (/["']/.test(v) || /\b(AND|OR|NOT)\b/.test(v)) {
        q = v;
      } else {
        var partes = v.split(/\s+/).filter(Boolean);
        if (marca && v.toLowerCase().indexOf(marca.toLowerCase()) === -1) partes.unshift(marca);
        q = partes.join(' AND ');
      }
      window.location.href = form.getAttribute('action') + '?q=' + encodeURIComponent(q) + '&type=product';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-hub"]) return;
  try {
    
(function(){
  function precisar(q){
    if (/["']/.test(q)) return q;
    if (/\b(AND|OR|NOT)\b/.test(q)) return q;
    var t = q.split(/\s+/).filter(Boolean);
    return t.length < 2 ? q : t.join(' AND ');
  }
  function iniciar(){
    var form = document.querySelector('[data-swc-hubform]');
    var input = document.querySelector('[data-swc-hubinput]');
    if (!form || !input || form.dataset.listo === '1') return;
    form.dataset.listo = '1';
    form.addEventListener('submit', function(e){
      var v = input.value.trim();
      if (!v) return;
      e.preventDefault();
      window.location.href = form.getAttribute('action') + '?q=' + encodeURIComponent(precisar(v)) + '&type=product';
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-modelo-guia"]) return;
  try {
    
(function(){
  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    raiz.dataset.swcListo = '1';
    var piezas = Array.prototype.slice.call(raiz.querySelectorAll('[data-sr-pieza]'));
    var cuenta = raiz.querySelector('[data-sr-cuenta]');
    var aviso = raiz.querySelector('[data-sr-aviso]');
    var avisoBase = aviso ? aviso.textContent : '';
    var grupo = 'todas', color = '';
    function pintar(){
      var visibles = 0, conColor = 0;
      piezas.forEach(function(p){
        var ok = grupo === 'todas' || p.getAttribute('data-grupo') === grupo;
        p.hidden = !ok;
        if (ok) visibles++;
        var tiene = !color || (p.getAttribute('data-colores') || '').indexOf('|' + color + '|') >= 0;
        p.classList.toggle('is-tenue', ok && !tiene);
        if (ok && tiene) conColor++;
      });
      if (cuenta){
        var t = visibles === 1 ? cuenta.getAttribute('data-uno') : cuenta.getAttribute('data-varios').replace('{n}', visibles);
        if (color){
          var b = raiz.querySelector('[data-sr-color="' + color + '"]');
          t = cuenta.getAttribute('data-color').replace('{n}', conColor).replace('{total}', visibles).replace('{color}', b ? b.getAttribute('data-sr-nombre') : '');
        }
        cuenta.textContent = t;
      }
    }
    raiz.querySelectorAll('[data-sr-grupo]').forEach(function(b){
      b.addEventListener('click', function(){
        grupo = b.getAttribute('data-sr-grupo');
        raiz.querySelectorAll('[data-sr-grupo]').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        pintar();
      });
    });
    raiz.querySelectorAll('[data-sr-color]').forEach(function(b){
      b.addEventListener('click', function(){
        var c = b.getAttribute('data-sr-color');
        color = (color === c) ? '' : c;
        raiz.querySelectorAll('[data-sr-color]').forEach(function(x){ x.setAttribute('aria-pressed', x.getAttribute('data-sr-color') === color ? 'true' : 'false'); });
        if (aviso){
          if (color){
            aviso.textContent = b.getAttribute('data-sr-nombre') + '. ' + avisoBase;
          } else { aviso.textContent = avisoBase; }
        }
        pintar();
        if (color){
          var pz = raiz.querySelector('#swc-sr-piezas');
          if (pz && pz.scrollIntoView) pz.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
    pintar();
  }
  function arrancar(){ document.querySelectorAll('[data-swc-sr]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swc-pieza-fotos"]) return;
  try {
    
(function(){
  function cargarResto(raiz){
    var paginas = parseInt(raiz.getAttribute('data-pf-paginas'), 10) || 1;
    var actual = parseInt(raiz.getAttribute('data-pf-actual'), 10) || 1;
    var url = raiz.getAttribute('data-pf-url');
    if (paginas < 2 || !url || !window.fetch || !window.Promise) return Promise.resolve(false);
    var tema = (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') ? '&preview_theme_id=' + Shopify.theme.id : '';
    var pedidos = [];
    for (var n = 1; n <= paginas; n++){
      if (n === actual) continue;
      pedidos.push(fetch(url + '?page=' + n + tema, { credentials: 'same-origin' }).then(function(r){ return r.ok ? r.text() : ''; }).catch(function(){ return ''; }));
    }
    return Promise.all(pedidos).then(function(textos){
      var grid = raiz.querySelector('[data-pf-grid]');
      var lista = raiz.querySelector('[data-pf-sin-lista]');
      textos.forEach(function(t){
        if (!t) return;
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var otra = doc.querySelector('[data-swc-pf]');
        if (!otra) return;
        otra.querySelectorAll('[data-pf-mod]').forEach(function(m){ grid.appendChild(document.importNode(m, true)); });
        otra.querySelectorAll('[data-pf-sin]').forEach(function(s){ lista.appendChild(document.importNode(s, true)); });
      });
      return true;
    });
  }
  function montar(raiz){
    var estado = raiz._swcPf || (raiz._swcPf = { marca: '', abierto: false });
    var caja = raiz.querySelector('[data-pf-caja]');
    var grid = raiz.querySelector('[data-pf-grid]');
    var mods = Array.prototype.slice.call(grid.querySelectorAll('[data-pf-mod]'));
    var cont = raiz.querySelector('[data-pf-pills]');
    var masCaja = raiz.querySelector('[data-pf-mas-caja]');
    var mas = raiz.querySelector('[data-pf-mas]');
    var limite = parseInt(raiz.getAttribute('data-pf-limite'), 10) || 48;
    var sinCaja = raiz.querySelector('[data-pf-sin-caja]');
    var sinTit = raiz.querySelector('[data-pf-sin-tit]');
    var nSin = raiz.querySelectorAll('[data-pf-sin]').length;
    if (sinTit) sinTit.textContent = (sinTit.getAttribute('data-plantilla') || '').replace('{n}', nSin);
    if (sinCaja) sinCaja.hidden = nSin === 0;
    caja.hidden = mods.length === 0;
    if (!mods.length) return;
    var marcas = {}, orden = [];
    mods.forEach(function(m){
      var h = m.getAttribute('data-marca');
      if (!marcas[h]){ marcas[h] = { n: 0, nombre: m.getAttribute('data-marca-nombre') }; orden.push(h); }
      marcas[h].n++;
    });
    orden.sort(function(a, b){ return marcas[b].n - marcas[a].n; });
    if (estado.marca && !marcas[estado.marca]) estado.marca = '';
    function pintar(){
      var n = 0;
      mods.forEach(function(m){
        var ok = !estado.marca || m.getAttribute('data-marca') === estado.marca;
        if (ok) n++;
        m.hidden = !ok || (!estado.marca && !estado.abierto && n > limite);
      });
      if (masCaja) masCaja.hidden = !!estado.marca || estado.abierto || mods.length <= limite;
    }
    raiz._swcPintar = pintar;
    function boton(h, txt, n){
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'swc-pf__pill';
      b.setAttribute('aria-pressed', h === estado.marca ? 'true' : 'false');
      b.setAttribute('data-swc-event', 'filter_click');
      b.setAttribute('data-swc-location', 'pieza_marca');
      b.appendChild(document.createTextNode(txt + ' '));
      var s = document.createElement('span');
      s.className = 'swc-pf__pill-n';
      s.textContent = n;
      b.appendChild(s);
      b.addEventListener('click', function(){
        estado.marca = h;
        cont.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        pintar();
      });
      return b;
    }
    cont.innerHTML = '';
    if (orden.length > 1){
      cont.hidden = false;
      cont.appendChild(boton('', cont.getAttribute('data-todas') || '', mods.length));
      orden.forEach(function(h){ cont.appendChild(boton(h, marcas[h].nombre, marcas[h].n)); });
    } else { cont.hidden = true; }
    if (mas && !mas.dataset.swcListo){
      mas.dataset.swcListo = '1';
      mas.addEventListener('click', function(){ estado.abierto = true; if (raiz._swcPintar) raiz._swcPintar(); });
    }
    pintar();
  }
  function enReposo(fn){
    var lanzar = function(){ if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 2500 }); else setTimeout(fn, 200); };
    if (document.readyState === 'complete') lanzar(); else window.addEventListener('load', lanzar, { once: true });
  }
  function iniciar(raiz){
    if (!raiz || raiz.dataset.swcListo === '1') return;
    raiz.dataset.swcListo = '1';
    var pag = raiz.querySelector('[data-pf-paginacion]');
    if (pag && window.fetch && window.Promise) pag.hidden = true;
    montar(raiz);
    enReposo(function(){ cargarResto(raiz).then(function(hubo){ if (hubo) montar(raiz); else if (pag) pag.hidden = false; }); });
  }
  function arrancar(){ document.querySelectorAll('[data-swc-pf]').forEach(iniciar); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arrancar); else arrancar();
  document.addEventListener('shopify:section:load', arrancar);
})();

  } catch(e) { console.error(e); }
})();
})();
